export default __webpack_public_path__ + "static/media/rabbit_type_12_3.c011b69a.svg";